import React from "react";
import point from "./../../../../Images/point.png";

const BridalMakeupInJakkurHow = () => {
  return (
    <div className="hairSalonInJakkurWhy">
      <h5>How to Prepare for Your Bridal Makeup in Jakkur</h5>
      <p>
        To get the most out of your Bridal Makeup in Jakkur experience, here are
        a few tips on how to prepare:
      </p>
      <ul>
        <li>
          <span>
            <img src={point} alt="point" />
            Skincare Routine:{" "}
          </span>
          <p>
            Start a good skincare routine months before your wedding. Healthy,
            hydrated skin is the perfect canvas for your bridal makeup.
          </p>
        </li>{" "}
        <li>
          <span>
            <img src={point} alt="point" />
            Communicate Your Vision:{" "}
          </span>
          <p>
            Bring inspiration photos to your consultation and be clear about
            your preferences. Our <a href="https://scentlifestyle.com/">Bridal Makeup in Jakkur</a> artists
            are here to bring your vision to life, so don’t be afraid to share
            your ideas.
          </p>
        </li>{" "}
        <li>
          <span>
            <img src={point} alt="point" />
            Stay Calm and Relaxed:{" "}
          </span>
          <p>
            On the day of your wedding, stay calm and relaxed. Trust in the
            process and the expertise of our Bridal Makeup in Jakkur team to
            create the perfect look for you.
          </p>
        </li>{" "}
      </ul>
    </div>
  );
};

export default BridalMakeupInJakkurHow;
